// extracted by mini-css-extract-plugin
export const contentWrapper = "confirmation-page-module--content-wrapper--K1VL0";
export const primaryContent = "confirmation-page-module--primary-content--J9Qv6";
export const secondaryContent = "confirmation-page-module--secondary-content--1D9-f";